module.exports = __webpack_public_path__ + "static/media/image-3-1024x541.5c8a91c7.png";